import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../UI/ScrollToTop';
import WhatsAppFloat from '../UI/WhatsAppFloat';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppFloat />
    </div>
  );
};

export default Layout;